import React from 'react'
import Star from '../../Assets/images/star.svg'
import Constant from '../../Constant'
import { motion } from 'framer-motion'
import FadeInSection from '../FadeInSection'

function Topsec() {
  return (
    <FadeInSection>
      <div className='faq-bg'>
        <div className='pt-[140px] pb-20 sm:pt-[177px]'>
          <div className='flex mx-auto px-6 sm:px-0 sm:w-[75%] md:w-[50%] justify-center'>
            <div className="text-center">
              <motion.p
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                className='inline-block bg-white p-3 text-[12px] font-[500] rounded-[32px] text-primary-color mb-4'
              >
                FAQ <img src={Star} alt='Star' className='inline' />
              </motion.p>

              <motion.h1
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
                className='text-[24px] mb-6 font-[24px] text-text-color1 sm:text-[48px]'
              >
                Everything <span className={Constant.linearColor}>you need</span> to know
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                viewport={{ once: true }}
                className='text-[14px] mb-10 font-[500] text-text-color1 sm:text-[20px]'
              >
                Need something cleared up? Here are our most frequently asked questions
              </motion.p>
            </div>
          </div>
        </div>
      </div>
    </FadeInSection>
  )
}

export default Topsec
